import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P58-E1',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page58/E1/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page58/E1/2.jpg' }],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P58-E2',
    audio: 'img/FriendsPlus/Page58/Audio/audio-e2-p58.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page58/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page58/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page58/Audio/tieude-e2-p58.mp3' },
        { url: 'img/FriendsPlus/Page58/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page58/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 8',
    id: 'SB3-U8-P58-E3',
    audio: '',
    video: '',
    component: T6,
    exerciseKey: 'img/FriendsPlus/Page58/E3/Key/answerKey.png',
    stylesTextInput: { borderBottomWidth: 0, backgroundColor: 'transparent' },
    titleQuestion: [{ num: '3', title: 'Read again. Match.', color: "#1F4199" }],
    inputSize: 34,
    maxLength: 1,
    textAlign: 'center',
    titleImage: "",
    questionImage: [],
    questions: [
      {
        title: `
        <div style='padding: 20px;position: relative;'>
        <div>
          <img src="img/FriendsPlus/Page58/E3/title.jpg" style="width: 100%">
          <img src="img/FriendsPlus/Page58/E3/title-02.jpg" style="width: 100%">
        </div>
        <div>
          <div style='display:flex;justify-content: space-between; position: absolute; top: 852px; left: 504px;'><input id='0' /></div>
          <div style='display:flex;justify-content: space-between; position: absolute; top: 852px; left: 757px;'><input id='1' /></div>
          <div style='display:flex;justify-content: space-between; position: absolute; top: 852px; left: 1029px;'><input id='2' /></div>
        </div>
      </div>
        `,
        answer: ['c', 'd', 'a'],
      },
    ],
  },
}

export default json;